import { useListItemDataProvider } from "@circle-react-shared/uikit/SortableList";
import { CommunitiesModalLink } from "./CommunitiesModalLink";

export const CommunityModalLinkDragOverlay = () => {
  const { item: community }: any = useListItemDataProvider();
  return <CommunitiesModalLink community={community} href="" />;
};
